import React, { useState } from 'react'
import NotificationCard from '../../components/elements/cards/NotificationCard'
import Pagination from '../../components/elements/Pagination'
import UserLayout from '../../components/layouts/UserLayout';

const Notifications = () => {
    const [perPage, setPerPage] = useState(25);
    const [page, setPage] = useState(1);

    const placeholderNotifications = [
        {
            date: new Date(),
            read: false,
            title: 'New admission offer',
            message: 'Convallis convallis tellus id interdum velit laoreet id.'
        },
        {
            date: new Date(),
            read: true,
            title: 'Disciplinary action for John Damsa',
            message: 'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur'
        },
        {
            date: new Date(),
            read: true,
            title: 'New document request for application - VCM/APP/2345/2024',
            message: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
        },
        {
            date: new Date(),
            read: false,
            title: 'New admission offer',
            message: 'Convallis convallis tellus id interdum velit laoreet id.'
        },
        {
            date: new Date(),
            read: true,
            title: 'Disciplinary action for John Damsa',
            message: 'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur'
        },
        {
            date: new Date(),
            read: true,
            title: 'New document request for application - VCM/APP/2345/2024',
            message: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
        },
    ]

    return (
        <UserLayout>
            <div className='lg:w-6/12 xl:w-5/12 mx-auto'>
                <div className='lg:p-4 rounded-t-[16px] bg-gray-150'>
                    <h3 className='text-[16px] font-[500] text-gray-700'>Your notifications</h3>
                </div>
                <div className='pb-4 lg:px-6'>
                
                    <>
                        {/* <p className='text-sm text-white text-opacity-80'>We currently have the following openings at Vaatia College Makurdi.</p> */}
                        <div className='flex items-center gap-x-3'>
                        <h3 className='text-[24px] text-gray-500'>12 <span className='text-[14px]'>notifications</span></h3>
                        <h3 className='text-[24px] text-gray-500'>4 <span className='text-[14px]'>unread</span></h3>
                        </div>

                        {placeholderNotifications.map((notification, notificationIndex)=>(
                        <NotificationCard key={notificationIndex} notification={notification} />
                        ))}
                    </>
                    {/* }
                    {admissionsSelector.admissions?.admissions?.length === 0 && <p className='text-sm text-white text-opacity-80'>There are no openings at Vaatia College Makurdi currently. Please check back later.</p>} */}
                    
                </div>
            </div>
            <div className='hidden lg:block w-full lg:w-10/12 mx-auto'>
                <Pagination pagination={{
                    perPage, 
                    currentPage: page,
                    totalItems: placeholderNotifications.length,
                }} changePage={(page)=>{setPage(page)}} updatePerPage={(perPage)=>{setPerPage(perPage)}} />
            </div>
        </UserLayout>
    )
}

export default Notifications